import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { ContractComponent } from './contract.component';
import { ContractRoutingModule } from './contract-routing.module';
import { ContractValidateModalComponent } from './components/contract-validate-modal/contract-validate-modal.component';
import { DividerModule } from 'primeng/divider';

@NgModule({
    declarations: [
        ContractComponent,
        ContractValidateModalComponent,
    ],
    imports: [
        ContractRoutingModule,
        CommonModule,
        RouterModule,
        SharedModule,
        DividerModule
    ]
})
export class ContractModule {}
